import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useSiteMode } from '../../contexts/SiteModeContext';
import { BrandMark } from './BrandMark';
import './FoundingMemberPage.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TesterLoginPage() {
  const navigate = useNavigate();
  const { refresh } = useSiteMode();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { document.title = 'SchedulesOfWork | Tester access'; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API}/tester/login`, { username, password }, { withCredentials: true });
      await refresh();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Username or password is incorrect.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="landing-v2 fm-page fm-tester-page">
      <header className="lv2-nav"><div className="lv2-nav-inner"><BrandMark /></div></header>
      <main className="fm-tester-main">
        <form className="fm-tester-card" onSubmit={submit} data-testid="tester-login-form">
          <h1 className="fm-tester-h1">Tester access</h1>
          <label className="fm-label" htmlFor="tester-username">Username</label>
          <input id="tester-username" className="fm-input" autoComplete="username" value={username}
            onChange={(e) => setUsername(e.target.value)} required data-testid="tester-username-input" />
          <label className="fm-label" htmlFor="tester-password">Password</label>
          <input id="tester-password" className="fm-input" type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} required data-testid="tester-password-input" />
          {error && <div className="fm-error" role="alert" data-testid="tester-login-error">{error}</div>}
          <button type="submit" className="fm-btn-primary fm-btn-block" disabled={busy} data-testid="tester-login-submit">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <Link to="/" className="fm-back-link" data-testid="tester-back-link">Back to home</Link>
        </form>
      </main>
    </div>
  );
}
